import { useMemo } from 'react';

import { SITE_ADDRESS, FULL_SITE_ADDRESS, CONTACTS_EMAIL } from '@constants/index';
import Text from '@components/Text';
import Title from '@components/Title';
import s from '@modules/static/components/StaticContract/StaticContract.module.scss';

const StaticTerms = () => {
  const siteName = `www.${SITE_ADDRESS}`;
  const site = FULL_SITE_ADDRESS;
  const privacyPolicyHref = `www.${SITE_ADDRESS}/privacy-policy`;
  const faqEmail = CONTACTS_EMAIL;

  const CHAPTERS = useMemo(
    () => [
      {
        title: '1. Общие положения',
        content: (
          <Text className={s.paragraph} fontgraphik>
            1.1. Настоящее Пользовательское соглашение (далее — Соглашение) относится к сайту{' '}
            <a className={s.bordered} href={site} rel="noreferrer" target="_blank">
              {siteName}
            </a>
            , расположенному по адресу{' '}
            <a className={s.bordered} href={site} rel="noreferrer" target="_blank">
              {site}
            </a>
            <br />
            1.2. Сайт{' '}
            <a className={s.bordered} href={site} rel="noreferrer" target="_blank">
              {siteName}
            </a>{' '}
            (далее — Сайт) является собственностью Общества с ограниченной ответственностью «ПРОГРЕСС» (ИНН:
            7714946124).
            <br />
            1.3. Настоящее Соглашение регулирует отношения между Администрацией Сайта (далее — Администрация сайта)
            и Пользователем данного Сайта.
            <br />
            1.4. Администрация сайта оставляет за собой право в любое время изменять, добавлять или удалять пункты
            настоящего Соглашения без уведомления Пользователя.
            <br />
            1.5. Использование Сайта Пользователем означает принятие Соглашения и изменений, внесенных в настоящее
            Соглашение.
            <br />
            1.6. Пользователь несет персональную ответственность за проверку настоящего Соглашения на наличие изменений
            в нем.
          </Text>
        ),
      },

      {
        title: '2. Определение терминов',
        content: (
          <Text className={s.paragraph} fontgraphik>
            2.1. Перечисленные ниже термины имеют для целей настоящего Соглашения следующее значение:
            <br />
            2.1.1. «
            <a href={site} rel="noreferrer" target="_blank">
              {siteName}
            </a>
            » — сайт, содержащий информацию об Услугах и/или Иных ценностях для пользователя, Продавце и/или Исполнителе
            услуг, позволяющий осуществить просмотр контента, подписку на рассылку, публикацию собственных комментариев
            к страницам сайта.
            <br />
            2.1.2. Администрация сайта — уполномоченные сотрудники на управления Сайтом, действующие от имени
            ООО «ПРОГРЕСС».
            <br />
            2.1.3. Пользователь сайта (далее — Пользователь) — физическое лицо, имеющее доступ к Сайту, посредством сети
            Интернет и использующее Сайт.
            <br />
            2.1.4. Содержание сайта (далее — Содержание) — охраняемые результаты интеллектуальной деятельности, включая
            тексты литературных произведений, их названия, предисловия, аннотации, статьи, иллюстрации, обложки,
            музыкальные произведения с текстом или без текста, графические, текстовые, фотографические, производные,
            составные и иные произведения, пользовательские интерфейсы, визуальные интерфейсы, названия товарных знаков,
            логотипы, программы для ЭВМ, базы данных, а также дизайн, структура, выбор, координация, внешний вид, общий
            стиль и расположение данного Содержания, входящего в состав Сайта и другие объекты интеллектуальной
            собственности все вместе и/или по отдельности, содержащиеся на сайте{' '}
            <a href={site} rel="noreferrer" target="_blank">
              {site}
            </a>
            .
          </Text>
        ),
      },

      {
        title: '3. Предмет соглашения',
        content: (
          <Text className={s.paragraph} fontgraphik>
            3.1. Предметом настоящего Соглашения является предоставление Пользователю доступа к содержащимся на Сайте
            информации.
            <br />
            3.1.1. Сайт предоставляет Пользователю следующие виды услуг (сервисов):
            <br />
            • предоставление Пользователю возможности регистрации Личного кабинета, размещения заявок, сообщений,
            комментариев, рецензий Пользователей, выставления оценок контенту сайта;
            <br />
            • возможность загружать персональные данные, заполнять и отправлять заявки на оказание услуг;
            <br />
            • возможность просмотра контента сайта.
            <br />
            3.1.2. Под действие настоящего Соглашения подпадают все существующие (реально функционирующие) на данный
            момент услуги (сервисы) Сайта, а также любые их последующие модификации и появляющиеся в дальнейшем
            дополнительные услуги (сервисы).
            <br />
            3.2. Доступ к сайту предоставляется на бесплатной основе.
            <br />
            3.3. Настоящее Соглашение является публичной офертой. Получая доступ к Сайту Пользователь считается
            присоединившимся к настоящему Соглашению.
            <br />
            3.4. Использование материалов и сервисов Сайта регулируется нормами действующего законодательства Российской
            Федерации.
          </Text>
        ),
      },

      {
        title: '4. Права и обязанности сторон',
        content: (
          <Text className={s.paragraph} fontgraphik>
            4.1. Администрация сайта вправе:
            <br />
            4.1.1. Изменять правила пользования Сайтом, а также изменять содержание данного Сайта. Изменения вступают
            в силу с момента публикации новой редакции Соглашения на Сайте.
            <br />
            4.2. Пользователь вправе:
            <br />
            4.2.1. Просматривать весь имеющийся на Сайте контент, оставлять к нему комментарии, пользоваться его
            сервисами.
            <br />
            4.2.2. Задавать любые вопросы, относящиеся к услугам сайта:
            <br />
            по электронной почте: <a href={`mailto:${faqEmail}`}>{faqEmail}</a>
            <br />
            4.2.3. Пользоваться Сайтом исключительно в целях и порядке, предусмотренных Соглашением и не запрещенных
            законодательством Российской Федерации.
            <br />
            4.2.4. Копировать информацию с Сайта разрешается только с указанием активной ссылкой на источник,
            не закрытой от индексации поисковыми системами.
            <br />
            4.2.5. Требовать от администрации скрытия любой информации о Пользователе.
            <br />
            4.2.6. Использовать информацию сайта в коммерческих целях без специального разрешения.
            <br />
            4.3. Пользователь Сайта обязуется:
            <br />
            4.3.1. Предоставлять по запросу Администрации сайта дополнительную информацию, которая имеет
            непосредственное отношение к предоставляемым услугам данного Сайта.
            <br />
            4.3.2. Соблюдать имущественные и неимущественные права авторов и иных правообладателей при использовании
            Сайта.
            <br />
            4.3.3. Не предпринимать действий, которые могут рассматриваться как нарушающие нормальную работу Сайта.
            <br />
            4.3.4. Не распространять с использованием Сайта любую конфиденциальную и охраняемую законодательством
            Российской Федерации информацию о физических либо юридических лицах.
            <br />
            4.3.5. Избегать любых действий, в результате которых может быть нарушена конфиденциальность охраняемой
            законодательством Российской Федерации информации.
            <br />
            4.3.6. Не использовать Сайт для распространения информации рекламного характера, иначе как с согласия
            Администрации сайта.
            <br />
            4.3.7. Не использовать сервисы с целью:
            <br />
            4.3.7.1. Нарушения прав несовершеннолетних лиц и (или) причинение им вреда в любой форме.
            <br />
            4.3.7.2. Ущемления прав меньшинств.
            <br />
            4.3.7.3. Представления себя за другого человека или представителя организации и (или) сообщества без
            достаточных на то прав, в том числе за сотрудников данного сайта.
            <br />
            4.3.7.4. Введения в заблуждение относительно свойств и характеристик какого-либо, контента, товара и/или
            услуги, размещенных на Сайте.
            <br />
            4.3.7.5. Некорректного сравнения контента, товара и/или Услуги, а также формирования негативного отношения
            к лицам, (не) пользующимся определенным контентом, товарами и/или услугами, или осуждения таких лиц.
            <br />
            4.3.7.6. Побуждения к совершению противоправных действий, а также содействия лицам, действия которых
            направлены на нарушение ограничений и запретов, действующих на территории Российской Федерации.
            <br />
            4.3.8. Обеспечить достоверность предоставляемой информации.
            <br />
            4.3.9. Обеспечивать сохранность личных данных от доступа третьих лиц.
            <br />
            4.4. Пользователю запрещается:
            <br />
            4.4.1. Использовать любые устройства, программы, процедуры, алгоритмы и методы, автоматические устройства
            или эквивалентные ручные процессы для доступа, приобретения, копирования или отслеживания содержания Сайта.
            <br />
            4.4.2. Нарушать надлежащее функционирование Сайта.
            <br />
            4.4.3. Любым способом обходить навигационную структуру Сайта для получения или попытки получения любой
            информации, документов или материалов любыми средствами, которые специально не представлены сервисами
            данного Сайта.
            <br />
            4.4.4. Несанкционированный доступ к функциям Сайта, любым другим системам или сетям, относящимся к данному
            Сайту, а также к любым услугам, предлагаемым на Сайте.
            <br />
            4.4.5. Нарушать систему безопасности или аутентификации на Сайте или в любой сети, относящейся к Сайту.
            <br />
            4.4.6. Выполнять обратный поиск, отслеживать или пытаться отслеживать любую информацию о любом другом
            Пользователе Сайта.
            <br />
            4.4.7. Использовать Сайт и его Содержание в любых целях, запрещенных законодательством Российской Федерации,
            а также подстрекать к любой незаконной деятельности или другой деятельности, нарушающей права Сайта или
            других лиц.
          </Text>
        ),
      },

      {
        title: '5. Использование сайта',
        content: (
          <Text className={s.paragraph} fontgraphik>
            5.1. Сайт и Содержание, входящее в состав Сайта, принадлежит и управляется Администрацией сайта.
            <br />
            5.2. Содержание Сайта защищено авторским правом, законодательством о товарных знаках, а также другими
            правами, связанными с интеллектуальной собственностью, и законодательством о недобросовестной конкуренции.
            <br />
            5.3. Настоящее Соглашение распространяет свое действия на все дополнительные положения и условия о просмотре
            контента, покупке Товара и/или оказанию услуг, предоставляемых на Сайте.
            <br />
            5.4. Информация, размещаемая на Сайте не должна истолковываться как изменение настоящего Соглашения.
            <br />
            5.5. Администрация сайта имеет право в любое время без уведомления Пользователя вносить изменения в перечень
            Товаров и услуг, предлагаемых на Сайте, и (или) их цен.
            <br />
            5.6. Документ указанный в пункте 5.7. настоящего Соглашения регулирует в соответствующей части
            и распространяет свое действие на использование Пользователем Сайта, а также на сбор, обработку и хранение
            его персональных данных.
            <br />
            5.7. Политика конфиденциальности размещена по следующему адресу:  
            <a href={privacyPolicyHref} rel="noreferrer" target="_blank">
              {privacyPolicyHref}.
            </a>
            <br />
            5.8. Документ, перечисленный в пункте 5.7. настоящего Соглашения может подлежать обновлению. Изменения
            вступают в силу с момента их обновления на Сайте.
          </Text>
        ),
      },

      {
        title: '6. Ответственность',
        content: (
          <Text className={s.paragraph} fontgraphik>
            6.1. Любые убытки, которые Пользователь может понести в случае умышленного или неосторожного нарушения
            любого положения настоящего Соглашения, а также вследствие несанкционированного доступа к коммуникациям
            другого Пользователя, Администрацией сайта не возмещаются.
            <br />
            6.2. Администрация сайта не несет ответственности за:
            <br />
            6.2.1. Задержки или сбои в процессе совершения операции, возникшие вследствие непреодолимой силы, а также
            любого случая неполадок в телекоммуникационных, компьютерных, электрических и иных смежных системах.
            <br />
            6.2.2. Надлежащее функционирование Сайта, в случае, если Пользователь не имеет необходимых технических
            средств для его использования, а также не несет никаких обязательств по обеспечению пользователей такими
            средствами.
          </Text>
        ),
      },

      {
        title: '7. Нарушение условий пользовательского соглашения',
        content: (
          <Text className={s.paragraph} fontgraphik>
            7.1. Администрация сайта имеет право раскрыть информацию о Пользователе, если действующее законодательство
            Российской Федерации требует или разрешает такое раскрытие.
            <br />
            7.2. Администрация сайта вправе без предварительного уведомления Пользователя прекратить и (или)
            заблокировать доступ к Сайту, если Пользователь нарушил настоящее Соглашение или содержащиеся в иных
            документах условия пользования Сайтом, а также в случае прекращения действия Сайта либо по причине
            технической неполадки или проблемы.
            <br />
            7.3. Администрация сайта не несет ответственности перед Пользователем или третьими лицами за прекращение
            доступа к Сайту в случае нарушения Пользователем любого положения настоящего Соглашения или иного документа,
            содержащего условия пользования Сайтом.
          </Text>
        ),
      },

      {
        title: '8. Разрешение споров',
        content: (
          <Text className={s.paragraph} fontgraphik>
            8.1. В случае возникновения любых разногласий или споров между Сторонами настоящего Соглашения обязательным
            условием до обращения в суд является предъявление претензии (письменного предложения о добровольном
            урегулировании спора).
            <br />
            8.2. Получатель претензии в течение 30 (тридцати) календарных дней со дня ее получения, письменно уведомляет
            заявителя претензии о результатах рассмотрения претензии.
            <br />
            8.3. При невозможности разрешить спор в добровольном порядке любая из Сторон вправе обратиться в суд
            за защитой своих прав, которые предоставлены им действующим законодательством Российской Федерации.
            <br />
            8.4. Любой иск в отношении условий использования Сайта должен быть предъявлен в течение 5 (пяти) рабочих
            дней после возникновения оснований для иска, за исключением защиты авторских прав на охраняемые
            в соответствии с законодательством материалы Сайта. При нарушении условий данного пункта любой иск
            оставляется судом без рассмотрения.
          </Text>
        ),
      },

      {
        title: '9. Дополнительные условия',
        content: (
          <Text className={s.paragraph} fontgraphik>
            9.1. Администрация сайта не принимает встречные предложения от Пользователя относительно изменений
            настоящего Пользовательского соглашения.
            <br />
            9.2. Отзывы Пользователя, размещенные на Сайте, не являются конфиденциальной информацией и могут быть
            использованы Администрацией сайта без ограничений.
          </Text>
        ),
      },

      {
        title: '10. Согласие на рассылку',
        content: (
          <Text className={s.paragraph} fontgraphik>
            10.1. На Сайте существует подписка на рассылку: уведомления, последние новости сайта, акции, рекламные
            предложения и иную информацию, которая представляет возможный интерес для подписчика.
            <br />
            10.2. Вводя свой e-mail в форму подписки и нажимая на кнопку «Получать», Пользователь дает бессрочное
            согласие на получение контента рассылки, а также обработку его персональных данных.
            <br />
            10.3. Подписчик рассылки может в любой момент отписаться от ее получения, нажав на специальную гиперссылку
            в одном из писем рассылки. Также можно запросить изменение или удаление своих данных посредством электронной
            почты.
          </Text>
        ),
      },
    ],
    [faqEmail, privacyPolicyHref, site, siteName]
  );

  return (
    <>
      <div className={s.chapterMain}>
        <Title className={s.title} level={1}>
          Пользовательское соглашение
        </Title>
      </div>

      {CHAPTERS.map((chapter) => (
        <div key={chapter.title} className={s.chapter}>
          <Title level={2}>{chapter.title}</Title>

          {Array.isArray(chapter.content)
            ? chapter.content.map((chapterContentPart) => (
                <>
                  <Text className={s.chapterSubTitle} size="large">
                    {chapterContentPart.title}
                  </Text>

                  <Text className={s.paragraph} fontgraphik>
                    {chapterContentPart.content}
                  </Text>
                </>
              ))
            : chapter.content}
        </div>
      ))}
    </>
  );
};

export default StaticTerms;
